import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import UpdateWall from './components/UpdateWall';
import EditorReview from './components/EditorReview';
import CTASection from './components/CTASection';

const homepageSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "韩漫漫画网-免费漫画大全-高清韩国漫画-无遮挡下拉式韩漫在线阅读",
  "description": "韩漫漫画网提供免费漫画大全，高清韩国漫画采用无遮挡下拉式在线阅读，界面简洁，加载迅速，让您享受流畅浏览过程。",
  "url": "http://vktest.com/",
  "isPartOf": {
    "@type": "WebSite",
    "name": "韩漫漫画网",
    "url": "http://vktest.com/"
  }
};

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <UpdateWall />
        <EditorReview />
        <CTASection />
      </main>
      <Footer />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(homepageSchema) }} />
    </>
  );
}